import { Button } from '@iveco-ti/iveco-ds'
import { ArrowLeft, Construction } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { twMerge } from 'tailwind-merge'

import Img from '@/assets/images/404.png'
import { ROUTES } from '../constants/routes'

type NotFoundProps = {
  authenticated: boolean
}

export function NotFound({ authenticated }: NotFoundProps) {
  const { t } = useTranslation('common')
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(authenticated ? ROUTES.PANEL.NEWS : ROUTES.LOGIN.SIGN_IN)
  }

  return (
    <div
      className={twMerge(
        'h-full max-h-[calc(100dvh-64px)]',
        authenticated &&
          'flex flex-col md:flex-row md:w-[calc(100dvw-265px)] static md:absolute md:left-[265px] md:top-16',
        !authenticated && 'flex flex-col justify-center items-center',
      )}
    >
      <div className="flex flex-1 flex-col justify-center items-center gap-4 p-4 min-w-1/2">
        <div className="flex flex-col gap-12">
          <div className="flex items-start gap-8">
            <Construction className="size-18 md:size-14 text-warning-500" />

            <div className="flex flex-col gap-12">
              <div className="space-y-4">
                <h1 className="text-6xl font-bold text-base-9002 flex items-center gap-2">
                  {t('components.not_found.title')}
                </h1>

                <h1 className="text-3xl md:text-5xl font-bold text-base-900">
                  {t('components.not_found.subtitle')}
                </h1>
              </div>

              <h2 className="text-lg md:text-xl text-base-600">
                {t('components.not_found.message')}
              </h2>

              <div className="max-w-fit">
                <Button.Root onClick={handleNavigate}>
                  <Button.Icon icon={ArrowLeft} />

                  {t('components.not_found.button')}
                </Button.Root>
              </div>
            </div>
          </div>
        </div>
      </div>

      {authenticated && (
        <div className="hidden md:flex justify-end">
          <img src={Img} alt={t('components.not_found.image')} />
        </div>
      )}
    </div>
  )
}
